import { useEffect } from 'react'
import { useInRouterContext, useLocation } from 'react-router-dom'
import useAnalytics from './useAnalytics'

/**
 * Wrapper component which sends route change events to Firefly Internal Insights.
 *
 * Must be rendered inside of a `<Router>`.
 * @param children
 * @param eventManagerConfiguration
 * @example
 * const App = () => (
 *   <Router>
 *     <LocationTracker eventManagerConfiguration={apiConfig.analytics}>
 *       <MyContent />
 *     </LocationTracker>
 *   </Router>
 * )
 */
const LocationTracker = () => {
  const isInRouter = useInRouterContext()

  // useLocation throws an error with unclear wording for our users if you call it outside of a router.
  // Given that hooks cannot be called conditionally, that means we can't put it in a try/catch block.
  // Better to detect early by trying to read the __RouterContext, and error out if it's not there.
  if (!isInRouter) {
    throw new Error(
      'Location tracking must be performed from inside a <Router>',
    )
  }

  const { pathname } = useLocation()
  const { trackView } = useAnalytics()

  useEffect(() => {
    trackView(pathname)
  }, [pathname, trackView])
  return null
}

export default LocationTracker
